import { useCallback, useEffect, useRef, useState } from 'react';
import apiClient from '@/utils/api';
import { toast } from 'sonner';

export const useNotificationPreferences = identity => {
  const [prefs, setPrefs] = useState({}), [loading, setLoading] = useState(true), [loadError, setLoadError] = useState(false);
  const [savingKey, setSavingKey] = useState(null);
  const version = useRef(0), saving = useRef(false);
  const load = useCallback(async () => {
    const id = ++version.current;
    setLoading(true); setLoadError(false);
    try { const result = await apiClient.get('/notifications/preferences'); if (id === version.current) setPrefs(result.data); }
    catch { if (id === version.current) setLoadError(true); }
    finally { if (id === version.current) setLoading(false); }
  }, []);
  useEffect(() => { saving.current = false; setSavingKey(null); load(); return () => { version.current++; }; }, [load, identity]);
  const toggle = async (key, checked) => {
    if (saving.current || loading || loadError) return;
    const id = version.current, previous = prefs[key];
    saving.current = true; setSavingKey(key);
    setPrefs(prev => ({ ...prev, [key]: checked }));
    try {
      const result = await apiClient.put('/notifications/preferences', { [key]: checked });
      if (id === version.current) setPrefs(result.data.preferences);
    } catch {
      if (id === version.current) { setPrefs(prev => ({ ...prev, [key]: previous })); toast.error('Could not save this notification preference'); }
    } finally { if (id === version.current) { saving.current = false; setSavingKey(null); } }
  };
  return { prefs, loading, loadError, savingKey, toggle, retry: load };
};